import { render, staticRenderFns } from "./ConfirmSignUp.vue?vue&type=template&id=185ce268&scoped=true"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=js"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ce268",
  null
  
)

export default component.exports